'use client';

import { usePathname } from 'next/navigation';
import HeaderActions from '@/components/ui/HeaderActions';

const PAGE_TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/workflows': 'Workflows',
  '/packages': 'Packages',
  '/logs': 'Logs',
  '/settings': 'Settings',
  '/reports': 'Reports',
  '/agent': 'Agent',
  '/admin': 'Admin',
  '/admin/affiliates': 'Affiliates',
  '/admin/tenants': 'Tenants',
};

// Desktop-only top bar inside <main>. On mobile the same actions render in
// the Sidebar's mobile topbar (right side), and the page title is redundant
// because the bottom MobileTabBar already labels the current view.
export default function Header() {
  const pathname = usePathname();

  const isEditor = pathname.startsWith('/workflows/') && pathname !== '/workflows';
  if (isEditor) return null;

  const title = Object.entries(PAGE_TITLES).find(([path]) =>
    path === '/' ? pathname === '/' : pathname.startsWith(path)
  )?.[1] || '';

  return (
    <div className="hidden md:flex sticky top-0 z-20 items-center justify-between px-4 sm:px-8 h-12 bg-[--bg-main]/80 backdrop-blur-md">
      <p className="text-xs sm:text-sm font-semibold text-[--text-secondary]">{title}</p>
      <div className="ml-auto">
        <HeaderActions />
      </div>
    </div>
  );
}
